/**
 * Material field validation constraints
 */
export const MaterialValidation = {
    NAME_MIN_LENGTH: 3,
    NAME_MAX_LENGTH: 50,
};

/**
 * Material validation error messages
 */
export const MaterialValidationMessages = {
    NAME_REQUIRED: 'Insira o título do material para continuar',
    NAME_TOO_SHORT: 'O título deve ter no mínimo 3 caracteres',
    NAME_TOO_LONG: 'O título deve ter no máximo 50 caracteres',
    COMMUNITY_INVALID: 'Comunidade inválida',
    MATERIAL_REQUIRED: 'Insira um material para continuar',
    AVAILABILITY_REQUIRED: 'Defina a disponibilidade do material',
    AVAILABILITY_PLANS_REQUIRED: 'Selecione pelo menos um plano para disponibilizar o material',
    TYPE_INVALID: 'Tipo de material inválido',
    ID_REQUIRED: 'ID do material não fornecido',
};

/**
 * Validate material name
 * @param {string} name - Material name to validate
 * @returns {{valid: boolean, error?: string}}
 */
export function validateMaterialName(name) {
    if (!name) {
        return {
            valid: false,
            error: MaterialValidationMessages.NAME_REQUIRED
        };
    }

    if (name.length < MaterialValidation.NAME_MIN_LENGTH) {
        return {
            valid: false,
            error: MaterialValidationMessages.NAME_TOO_SHORT
        };
    }

    if (name.length > MaterialValidation.NAME_MAX_LENGTH) {
        return {
            valid: false,
            error: MaterialValidationMessages.NAME_TOO_LONG
        };
    }

    return { valid: true };
}

/**
 * Normalize API or form availability to internal shape: undefined | null | number[]
 * - API may send { plans: [...] } or legacy array
 * - ["all"] or { plans: ["all"] } → null (public)
 * - { plans: null } → null (public)
 * @param {*} availability
 * @returns {undefined|null|number[]}
 */
export function normalizeAvailabilityForForm(availability) {
    if (availability === undefined) return undefined;
    if (availability === null) return null;

    if (Array.isArray(availability)) {
        if (availability.includes('all')) return null;
        return availability;
    }

    if (typeof availability === 'object' && availability !== null && 'plans' in availability) {
        if (availability.plans === null || availability.plans === undefined) {
            return null;
        }
        if (Array.isArray(availability.plans)) {
            if (availability.plans.includes('all')) return null;
            return availability.plans;
        }
    }

    return undefined;
}

/**
 * Serialize internal availability for API: { plans: null } (public) or { plans: [...] }
 * @param {null|number[]} availability
 * @returns {{ plans: null|number[] }}
 */
export function availabilityToPayload(availability) {
    if (availability === null) {
        return { plans: null };
    }
    return { plans: availability };
}

/**
 * Validate material availability
 * - null means "public/available to all" (valid)
 * - array must have at least one plan ID if specified
 * @param {Array|null} availability - Material availability
 * @returns {{valid: boolean, error?: string}}
 */
export function validateMaterialAvailability(availability) {
    // undefined is not allowed
    if (availability === undefined) {
        return {
            valid: false,
            error: MaterialValidationMessages.AVAILABILITY_REQUIRED
        };
    }

    // null means "public/all" - valid
    if (availability === null) {
        return { valid: true };
    }

    // If it's an array (specific plans mode), must have at least one plan
    if (Array.isArray(availability)) {
        if (availability.length === 0) {
            return {
                valid: false,
                error: MaterialValidationMessages.AVAILABILITY_PLANS_REQUIRED
            };
        }
        return { valid: true };
    }

    // Invalid type
    return {
        valid: false,
        error: MaterialValidationMessages.AVAILABILITY_REQUIRED
    };
}
